import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormFreeTextField } from '@grupo-constant/next-dtype/form';
import { SECTION_COLUMN_URI, SUBSECTION_COLUMN_URI } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { LocalizePipe } from '../../../pipes/standalone/localize.pipe';
import { SafeHtmlPipe } from '../../../pipes/safehtml.pipe';

@Component({
    selector: 'freetext-field-component',
    templateUrl: './freetext-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, LocalizePipe, SafeHtmlPipe]
})
export class DtypeFreetextFieldComponent implements DTypeFormFieldComponent {

    @Input() field: DTypeFormFreeTextField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    sectionUri = SECTION_COLUMN_URI;
    subsectionUri = SUBSECTION_COLUMN_URI;

    constructor() { }

}
